/**
 * Shows an error notification using the available notification system
 * @param {String|Array} errors - Error message(s) to display
 * @param {Boolean} autohide - Whether to auto-hide the notification. Default is true
 */
function showErrorNotification(errors, autohide = true) {
  const errorsList = Array.isArray(errors) ? errors : errors?.split(', ') || []
  const errorMessage = errorsList.join('\n')

  if (window.showNotification) {
    window.showNotification(errorMessage, { type: 'error', autohide })
  } else {
    App.events.publish('app:notification:flash:error', errorMessage, autohide)
  }
}

export default showErrorNotification
